<template>
    <rkm-alert>
        <rkm-row>
            <rkm-col cols="6">
                <span>
                    <strong>Paciente:</strong> {{ form.nomePaciente }} <strong v-if="form.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL"> ({{ form.nomeSocial }})</strong>
                </span>
            </rkm-col>

            <rkm-col cols="6">
                <span>
                    <strong>Nome da mãe:</strong> {{ form.nomeMae || 'Não informado' }}
                </span>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <span>
                    <strong>Data de nascimento:</strong> {{ form.dataNascimento || 'Não informado' }}
                </span>
            </rkm-col>

            <rkm-col cols="3">
                <span>
                    <strong>CPF:</strong> {{ form.cpf || 'Não informado' }}
                </span>
            </rkm-col>

            <rkm-col cols="3">
                <span>
                    <strong>CNS:</strong> {{ form.cns || 'Não informado' }}
                </span>
            </rkm-col>
        </rkm-row>
    </rkm-alert>
</template>

<script>

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    data: () => ({
        enums: { preferenciaNome }
    }),
    props: {
        form: { type: Object, required: true },
    }
}
</script>